import { observer } from 'mobx-react'
import React from 'react'
import DecorationMobx from '@mobx/app/decoration.mobx'

import './index.scss'

interface IProps {}

const HeaderBack: React.FC<IProps> = (props: IProps) => {
  const {
    mktDecorates
  } = DecorationMobx
  return (
    <div
      className='header-panel-back'
      style={mktDecorates.member.bgType === 'color' ? {
        backgroundColor: mktDecorates.member.bgValue
      } : {
        backgroundImage: `Url(${mktDecorates.member.bgValue})`
      }}
    >
    </div>
  )
}

export default observer(HeaderBack)
